import React, { useMemo, useState } from 'react';
import PageHeader from '../../components/shared/PageHeader';
import DataToolbar, { Card } from '../../components/shared/DataToolbar';
import { LoadingState, ErrorState, EmptyResults } from '../../components/shared/Pending';
import { useApi } from '../../api/useApi';
import { listAuditLogs } from '../../api/adminApi';
import { Download, ScrollText } from 'lucide-react';
import { Button } from '../../components/ui/button';

export default function AdminAuditLogs() {
  const { data, loading, error, refetch } = useApi(listAuditLogs, []);
  const logs = useMemo(() => Array.isArray(data) ? data : (data?.items || data || []), [data]);
  const [q, setQ] = useState('');
  const filtered = logs.filter(l => !q || `${l.actor || ''} ${l.action || ''} ${l.entity || ''}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <PageHeader title="Audit logs" description="Immutable record of administrative actions."
        actions={<Button variant="outline" className="h-10"><Download className="h-4 w-4 mr-1" /> Export</Button>} />
      <DataToolbar search={q} onSearch={setQ} placeholder="Search actor, action or entity…" />
      {loading ? <LoadingState /> : error ? <ErrorState error={error} onRetry={refetch} />
        : filtered.length === 0 ? <EmptyResults icon={ScrollText} title="No audit logs" />
        : (
          <Card className="overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider"><tr><th className="text-left font-medium px-4 py-3">Timestamp</th><th className="text-left font-medium px-4 py-3">Actor</th><th className="text-left font-medium px-4 py-3">Action</th><th className="text-left font-medium px-4 py-3">Entity</th><th className="text-left font-medium px-4 py-3">IP</th></tr></thead>
              <tbody className="divide-y divide-slate-100">
                {filtered.map(l => (
                  <tr key={l.id} className="hover:bg-slate-50">
                    <td className="px-4 py-3 text-xs text-slate-600 font-mono">{l.created_at || l.at}</td>
                    <td className="px-4 py-3">{l.actor}</td>
                    <td className="px-4 py-3"><span className="font-mono text-xs px-2 py-0.5 rounded bg-slate-100 text-slate-700">{l.action}</span></td>
                    <td className="px-4 py-3 font-mono text-xs text-slate-600">{l.entity}</td>
                    <td className="px-4 py-3 text-xs text-slate-500">{l.ip}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        )
      }
    </div>
  );
}
